import clsx from "clsx";
import { useState } from "react";
import VasTab from "./components/vas-tab.component";
import TransactionTab from "./components/transaction-tab.component";

enum HistoryTab {
  TRANSACTION = 1,
  VAS = 2,
}

function TransactionUser() {
  const [activedTab, setActivedTab] = useState(HistoryTab.TRANSACTION);

  const handleTabClick = (tab: any) => {
    setActivedTab(tab);
  };

  const render = () => {
    switch (activedTab) {
      case HistoryTab.TRANSACTION:
        return <TransactionTab />;
      case HistoryTab.VAS:
        return <VasTab />;
    }
  };

  return (
    <div>
      <div className="flex gap-10 my-4">
        <div
          onClick={() => handleTabClick(HistoryTab.TRANSACTION)}
          className={clsx("cursor-pointer font-medium font-[SVN-Gilroy]", {
            "text-[#38499b]": activedTab === HistoryTab.TRANSACTION,
          })}
        >
          Giao dịch
        </div>
        <div
          onClick={() => handleTabClick(HistoryTab.VAS)}
          className={clsx("cursor-pointer font-medium font-[SVN-Gilroy]", {
            "text-[#38499b]": activedTab === HistoryTab.VAS,
          })}
        >
          Kas
        </div>
      </div>
      {render()}
    </div>
  );
}

export default TransactionUser;
